import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import { Button } from '@tcc/crate';

const baseString = 'vra-scripting-card-trigger';
const ScriptingCardTrigger = ({
  isDisabled=false,
  isHidden=false,
  isPrimary=false,
  onClick,
  testId,
  text,
  triggerClassString
}) => {

  const mode = isPrimary ? 'primary' : 'secondary';

  const classString = classNames({
    [`${baseString}`]: true,
    [`${triggerClassString}`]: !!triggerClassString
  });

  return isHidden ? null : (
    <Button
      className={classString}
      data-test-id={testId}
      disabled={isDisabled}
      mode={mode}
      onClick={onClick}>
      {text}
    </Button>
  );
};
ScriptingCardTrigger.propTypes = {
  isDisabled: propTypes.bool,
  isHidden: propTypes.bool,
  isPrimary: propTypes.bool,
  onClick: propTypes.func.isRequired,
  testId: propTypes.string.isRequired,
  text: propTypes.string.isRequired,
  triggerClassString: propTypes.string
};
export default ScriptingCardTrigger;
